import type { ILandingEventTypeCounts, ILandingTelegramAuthFunnelCounts } from '@/entities/landing.entity';
import { sumClassicLandingEventCounts } from '@/entities/landing.entity';
import { BarChart3Icon, ShieldCheckIcon } from 'lucide-react';

interface LandingEventsHeroCardProps {
	classicAllTime: ILandingEventTypeCounts;
	telegramAuth: ILandingTelegramAuthFunnelCounts;
}

export default function LandingEventsHeroCard({ classicAllTime, telegramAuth }: LandingEventsHeroCardProps) {
	const classicTotal = sumClassicLandingEventCounts(classicAllTime);

	return (
		<div className='grid gap-3 sm:grid-cols-2'>
			<div className='rounded-xl border border-chart-1/20 bg-gradient-to-br from-chart-1/20 via-chart-1/10 to-transparent p-5 flex flex-col gap-1'>
				<div className='flex items-center gap-2 text-xs text-muted-foreground'>
					<BarChart3Icon size={14} className='text-chart-1' />
					Трафик (всего)
				</div>
				<span className='text-3xl font-bold tabular-nums text-chart-1'>{classicTotal.toLocaleString('ru-RU')}</span>
				<span className='text-sm text-muted-foreground'>
					connect / download / form за всё время
				</span>
			</div>
			<div className='rounded-xl border border-chart-4/20 bg-gradient-to-br from-chart-4/20 via-chart-4/10 to-transparent p-5 flex flex-col gap-1'>
				<div className='flex items-center gap-2 text-xs text-muted-foreground'>
					<ShieldCheckIcon size={14} className='text-chart-4' />
					TG auth
				</div>
				<span className='text-3xl font-bold tabular-nums text-chart-4'>
					{telegramAuth.sessions.toLocaleString('ru-RU')}
					<span className='text-lg font-medium text-muted-foreground'> / {telegramAuth.starts.toLocaleString('ru-RU')}</span>
				</span>
				<span className='text-sm text-muted-foreground'>сессии / старты (всего)</span>
			</div>
		</div>
	);
}
